module.exports = __webpack_public_path__ + "img/Adel Attari.aa9b6d1e.jpg";